import React, { useState, useEffect } from 'react';
import arrow from '../Icons/arrow.svg';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import Select from 'react-select';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from 'react-router-dom';
import '../Customize_Css/AddVendor.css';

const UpdatePromoCode = () => {
  const navigate = useNavigate();
  const { id: promoCodeId } = useParams();
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');

  const [isActive, setIsActive] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [promoCodeName, setPromoCodeName] = useState('');
  const [promoCodeType, setPromoCodeType] = useState('');
  const [promoCodeValue, setPromoCodeValue] = useState('');
  const [promoCodeUsageLimit, setPromoCodeUsageLimit] = useState('');
  const [minimumOrderValue, setMinimumOrderValue] = useState('');
  const [maximumDiscountValue, setMaximumDiscountValue] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [promoCodeDescription, setPromoCodeDescription] = useState('');
  const [vendors, setVendors] = useState([]);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [promoType, setPromoType] = useState('');
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [totalUsageLimit, setTotalUsageLimit] = useState('');
  const [applicableUsers, setApplicableUsers] = useState('');
  const [deliveryChargeWaiver, setDeliveryChargeWaiver] = useState(false);
  const [cashbackOffer, setCashbackOffer] = useState(false);
  const [appliedAutomatically, setAppliedAutomatically] = useState(false);
  const [errors, setErrors] = useState({});
  const [validFields, setValidFields] = useState({});

  const resetForm = () => {
    setPromoCodeName('');
    setPromoCodeType('');
    setPromoCodeValue('');
    setPromoCodeUsageLimit('');
    setMinimumOrderValue('');
    setMaximumDiscountValue('');
    setPromoType('');
    setSelectedProducts([]);
    setSelectedCategories([]);
    setSelectedUsers([]);
    setStartDate('');
    setEndDate('');
    setApplicableUsers('');
    setPromoCodeDescription('');
    setTotalUsageLimit('');
    setIsActive(false);
    setDeliveryChargeWaiver(false);
    setCashbackOffer(false);
    setAppliedAutomatically(false);
    setShowUserDropdown(false);
    setErrors({});
  };

  const validateField = (id, value) => {
    const isEmpty = (val) => !val || val.toString().trim() === "";
    const isValidPositiveNumber = (val) => !isNaN(val) && Number(val) > 0;
    const isEndDateValid = (endDate) => endDate && new Date(endDate) > new Date(startDate || new Date());

    const validationRules = {
      promoCodeName: { message: "Promo Code Name is required", validator: (val) => !isEmpty(val) },
      promoCodeType: { message: "Discount Type is required", validator: (val) => !isEmpty(val) },
      promoCodeValue: { message: "Discount Value must be a positive number", validator: isValidPositiveNumber },
      promoType: { message: "Promo Type is required", validator: (val) => !isEmpty(val) },
      startDate: { message: "Start Date is required", validator: (val) => !isEmpty(val) },
      endDate: { message: "End Date must be after Start Date", validator: isEndDateValid },
      applicableUsers: { message: "Applicable Users is required", validator: (val) => !isEmpty(val) },
      promoCodeDescription: { message: "Description is required", validator: (val) => !isEmpty(val) },
      isActive: { message: "Active/Deactivate status is required", validator: (val) => typeof val === "boolean" },
    };

    const rule = validationRules[id];
    if (!rule) return;

    const isValid = rule.validator(value);
    setErrors((prev) => isValid ? { ...prev, [id]: "" } : { ...prev, [id]: rule.message });
    setValidFields((prev) => isValid ? { ...prev, [id]: true } : { ...prev, [id]: false });
  };

  const validateForm = () => {
    let isValid = true;
    const fieldsToValidate = [
      "promoCodeName", "promoCodeType", "promoCodeValue", "promoType",
      "startDate", "endDate", "applicableUsers", "promoCodeDescription", "isActive"
    ];

    fieldsToValidate.forEach((id) => {
      const value = id === "isActive" ? isActive : 
                    id === "promoCodeName" ? promoCodeName :
                    id === "promoCodeType" ? promoCodeType :
                    id === "promoCodeValue" ? promoCodeValue :
                    id === "promoType" ? promoType :
                    id === "startDate" ? startDate :
                    id === "endDate" ? endDate :
                    id === "applicableUsers" ? applicableUsers :
                    id === "promoCodeDescription" ? promoCodeDescription : "";
      validateField(id, value);
      if (errors[id]) isValid = false;
    });

    return isValid;
  };

  useEffect(() => {
    const fetchPromoCodeData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/promoCode/api/promoCode/${epicxTenantId}/${promoCodeId}`,
          {
            headers: {
              Authorization: `Bearer ${AuthorizationToken}`,
            },
          }
        );
        const result = response.data;
        setPromoCodeName(result.promoCodeName);
        setPromoCodeType(result.promoCodeType);
        setPromoCodeValue(result.promoCodeValue);
        setPromoCodeUsageLimit(result.promoCodeUsageLimit || '');
        setMinimumOrderValue(result.minimumOrderValue || '');
        setMaximumDiscountValue(result.maximumDiscountValue || '');
        setStartDate(result.startDate.split('T')[0]);
        setEndDate(result.endDate.split('T')[0]);
        setPromoCodeDescription(result.promoCodeDescription);
        setIsActive(result.isActive);
        setPromoType(result.promoType);
        setShowUserDropdown(result.promoType === 'private');
        setTotalUsageLimit(result.totalUsageLimit || '');
        setApplicableUsers(result.applicableUsers);
        setDeliveryChargeWaiver(result.deliveryChargeWaiver);
        setCashbackOffer(result.cashbackOffer);
        setAppliedAutomatically(result.appliedAutomatically);
        setSelectedProducts(result.applicableProducts.map(p => ({ value: p.id, label: p.name })));
        setSelectedCategories(result.categories.map(c => ({ value: c.id, label: c.name })));
        setSelectedUsers(result.selectedUsers.map(u => ({ value: u.id, label: u.name })));
      } catch (error) {
        console.error('Error fetching promo code data:', error);
        toast.error('Error fetching promo code data');
      }
    };
    if (epicxTenantId && promoCodeId) fetchPromoCodeData();
  }, [epicxTenantId, promoCodeId]);

  useEffect(() => {
    const fetchActiveCategories = async () => {
      try {
        const response = await fetch(`${BASE_URL}/products/api/category/`,{
          headers: {
            Authorization: `Bearer ${AuthorizationToken}`,
          },
        });
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        const categoryOptions = data.map((category) => ({
          value: category._id,
          label: category.categoryName,
        }));
        setCategories(categoryOptions);
      } catch (error) {
        console.error('Error fetching categories:', error);
        toast.error('Error fetching categories');
      }
    };
    if (epicxTenantId) fetchActiveCategories();
  }, [epicxTenantId]);

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await fetch(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}`
          ,{
            headers: {
              Authorization: `Bearer ${AuthorizationToken}`,
            }
          }
        );
        const data = await response.json();
        if (data.vendors) setVendors(data.vendors);
      } catch (error) {
        console.error('Error fetching vendor data:', error);
      }
    };
    fetchVendors();
  }, [epicxTenantId]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/promoCode/api/promoCode/active-products/${epicxTenantId}`,
          {
            headers: {
              Authorization: `Bearer ${AuthorizationToken}`,
            }
          }
        );
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, [epicxTenantId]);

  const productOptions = products.map((product) => ({
    value: product._id,
    label: product.productName,
  }));

  const userOptions = vendors.map((vendor) => ({
    value: vendor._id,
    label: vendor.vendorName,
  }));

  const handleUpdatePromoCode = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error('Please fill all required fields correctly');
      return;
    }

    const updatedPromoCodeData = {
      promoCodeName,
      promoCodeType,
      promoCodeValue: Number(promoCodeValue),
      promoType,
      applicableProducts: selectedProducts.map((product) => ({
        id: product.value,
        name: product.label,
      })),
      categories: selectedCategories.map((category) => ({
        id: category.value,
        name: category.label,
      })),
      selectedUsers: selectedUsers.map((user) => ({
        id: user.value,
        name: user.label,
      })),
      startDate,
      endDate,
      applicableUsers,
      promoCodeDescription,
      isActive,
      deliveryChargeWaiver,
      cashbackOffer,
      appliedAutomatically,
      minimumOrderValue,
      totalUsageLimit,
      maximumDiscountValue,
      promoCodeUsageLimit,
    };

    try {
      const response = await axios.put(
        `${BASE_URL}/promoCode/api/promoCode/${epicxTenantId}/${promoCodeId}`,
        updatedPromoCodeData,
        { headers: { 'Content-Type': 'application/json',
          Authorization: `Bearer ${AuthorizationToken}` } }
      );
      toast.success('Promo code updated successfully');
      console.log('Promo code updated:', response.data);
    } catch (error) {
      toast.error('Error updating promo code. Please try again');
      console.error('API Error:', error);
    }
  };

  const handleToggle = () => {
    setIsActive(!isActive);
    validateField('isActive', !isActive);
  };

  const handlePromoTypeChange = (e) => {
    const selectedValue = e.target.value;
    setPromoType(selectedValue);
    setShowUserDropdown(selectedValue === 'private');
    validateField('promoType', selectedValue);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#f8f9fa',
      borderColor: '#ced4da',
      boxShadow: 'none',
      '&:hover': { borderColor: '#80bdff' },
    }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  return (
    <>
      <Sidebar />
      <div className="vendor-form-page">
        <div className="vendor-form-shell">
          <header className="vendor-form-hero">
            <div>
              <p className="vendor-form-kicker">Sales</p>
              <h1>Update Promo Code</h1>
              <p>Review the code, then change the discount, dates, products, or status.</p>
            </div>
            <button type="button" className="vendor-form-back-btn" onClick={() => navigate('/view-promocode')}>Back to Promo Codes</button>
          </header>
          <div>
            <div className="vendor-form-card">
              <div className="vendor-form-card-head">
                <div>
                  <h2>Promo Code Information</h2>
                  <p>Discount, dates, products, and how this code is applied.</p>
                </div>
              </div>
              <div className="vendor-form-card-body">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="promoCodeName">Promo Code Name</label>
                      <span style={{ color: 'red' }}>*</span>
                      <input
                        type="text"
                        className={`form-control bg-light ${errors.promoCodeName ? 'is-invalid' : validFields.promoCodeName ? 'is-valid' : ''}`}
                        id="promoCodeName"
                        placeholder="Enter promo code name"
                        value={promoCodeName}
                        onChange={(e) => setPromoCodeName(e.target.value)}
                        onBlur={(e) => validateField('promoCodeName', e.target.value)}
                      />
                      {errors.promoCodeName && <small className="text-danger">{errors.promoCodeName}</small>}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="promoCodeType">Discount Type</label>
                      <span style={{ color: 'red' }}>*</span>
                      <select
                        className={`form-control bg-light ${errors.promoCodeType ? 'is-invalid' : validFields.promoCodeType ? 'is-valid' : ''}`}
                        id="promoCodeType"
                        style={{
                          backgroundImage: `url(${arrow})`,
                          backgroundPosition: 'right 10px center',
                          backgroundRepeat: 'no-repeat',
                          backgroundSize: '16px 16px',
                          paddingRight: '30px',
                          color: 'gray',
                        }}
                        value={promoCodeType}
                        onChange={(e) => setPromoCodeType(e.target.value)}
                        onBlur={(e) => validateField('promoCodeType', e.target.value)}
                      >
                        <option value="">Select type</option>
                        <option value="percentage">Percentage</option>
                        <option value="fixedAmount">Fixed Amount</option>
                        <option value="freeDelivery">Free Delivery</option>
                      </select>
                      {errors.promoCodeType && <small className="text-danger">{errors.promoCodeType}</small>}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="promoCodeValue">Discount Value</label>
                      <span style={{ color: 'red' }}>*</span>
                      <input
                        type="text"
                        className={`form-control bg-light ${errors.promoCodeValue ? 'is-invalid' : validFields.promoCodeValue ? 'is-valid' : ''}`}
                        id="promoCodeValue"
                        placeholder="Enter promo code value"
                        value={promoCodeValue}
                        onChange={(e) => setPromoCodeValue(e.target.value)}
                        onBlur={(e) => validateField('promoCodeValue', e.target.value)}
                      />
                      {errors.promoCodeValue && <small className="text-danger">{errors.promoCodeValue}</small>}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="promoCodeUsageLimit">Usage Limit (Per User)</label>
                    <input
                      type="number"
                      id="promoCodeUsageLimit"
                      className="form-control bg-light"
                      value={promoCodeUsageLimit}
                      onChange={(e) => setPromoCodeUsageLimit(e.target.value.replace(/\D/g, ''))}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="totalUsageLimit">Total Usage Limit</label>
                    <input
                      type="number"
                      id="totalUsageLimit"
                      className="form-control bg-light"
                      value={totalUsageLimit}
                      onChange={(e) => setTotalUsageLimit(e.target.value.replace(/\D/g, ''))}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="minimumOrderValue">Minimum Order Amount</label>
                    <input
                      type="number"
                      id="minimumOrderValue"
                      className="form-control bg-light"
                      value={minimumOrderValue}
                      onChange={(e) => setMinimumOrderValue(e.target.value.replace(/\D/g, ''))}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="maximumDiscountValue">Maximum Discount Amount</label>
                    <input
                      type="number"
                      id="maximumDiscountValue"
                      className="form-control bg-light"
                      value={maximumDiscountValue}
                      onChange={(e) => setMaximumDiscountValue(e.target.value.replace(/\D/g, ''))}
                    />
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="promoType">Promo Type</label>
                      <span style={{ color: 'red' }}>*</span>
                      <select
                        className={`form-control bg-light ${errors.promoType ? 'is-invalid' : validFields.promoType ? 'is-valid' : ''}`}
                        id="promoType"
                        style={{
                          backgroundImage: `url(${arrow})`,
                          backgroundPosition: 'right 10px center',
                          backgroundRepeat: 'no-repeat',
                          backgroundSize: '16px 16px',
                          paddingRight: '30px',
                          color: 'gray',
                        }}
                        value={promoType}
                        onChange={handlePromoTypeChange}
                        onBlur={(e) => validateField('promoType', e.target.value)}
                      >
                        <option value="">Select type</option>
                        <option value="public">Public</option>
                        <option value="private">Private</option>
                      </select>
                      {errors.promoType && <small className="text-danger">{errors.promoType}</small>}
                    </div>
                  </div>
                  {showUserDropdown && (
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="userSelect">Select Users</label>
                        <Select
                          isMulti
                          options={userOptions}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          value={selectedUsers}
                          onChange={setSelectedUsers}
                          styles={customStyles}
                        />
                      </div>
                    </div>
                  )}
                  <div className="col-md-4">
                    <label htmlFor="applicableProducts">Applicable Products</label>
                    <Select
                      id="applicableProducts"
                      options={productOptions}
                      isMulti
                      value={selectedProducts}
                      onChange={setSelectedProducts}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={customStyles}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="categories">Categories</label>
                    <Select
                      id="categories"
                      options={categories}
                      isMulti
                      value={selectedCategories}
                      onChange={setSelectedCategories}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={customStyles}
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="startDate">Valid From Date</label>
                    <span style={{ color: 'red' }}>*</span>
                    <input
                      type="date"
                      className={`form-control bg-light ${errors.startDate ? 'is-invalid' : validFields.startDate ? 'is-valid' : ''}`}
                      id="startDate"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      onBlur={(e) => validateField('startDate', e.target.value)}
                    />
                    {errors.startDate && <small className="text-danger">{errors.startDate}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="endDate">Valid Till Date</label>
                    <span style={{ color: 'red' }}>*</span>
                    <input
                      type="date"
                      className={`form-control bg-light ${errors.endDate ? 'is-invalid' : validFields.endDate ? 'is-valid' : ''}`}
                      id="endDate"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      onBlur={(e) => validateField('endDate', e.target.value)}
                    />
                    {errors.endDate && <small className="text-danger">{errors.endDate}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="applicableUsers">Applicable for (Users)</label>
                    <span style={{ color: 'red' }}>*</span>
                    <select
                      className={`form-control bg-light ${errors.applicableUsers ? 'is-invalid' : validFields.applicableUsers ? 'is-valid' : ''}`}
                      id="applicableUsers"
                      value={applicableUsers}
                      onChange={(e) => setApplicableUsers(e.target.value)}
                      onBlur={(e) => validateField('applicableUsers', e.target.value)}
                    >
                      <option value="">Select Users</option>
                      <option value="new">New User</option>
                      <option value="existing">Existing User</option>
                      <option value="all">All</option>
                    </select>
                    {errors.applicableUsers && <small className="text-danger">{errors.applicableUsers}</small>}
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="promoCodeDescription">Promo Code Description</label>
                    <span style={{ color: 'red' }}>*</span>
                    <textarea
                      className={`form-control bg-light ${errors.promoCodeDescription ? 'is-invalid' : validFields.promoCodeDescription ? 'is-valid' : ''}`}
                      id="promoCodeDescription"
                      rows="1"
                      placeholder="Enter Promo Code Description Here"
                      value={promoCodeDescription}
                      onChange={(e) => setPromoCodeDescription(e.target.value)}
                      onBlur={(e) => validateField('promoCodeDescription', e.target.value)}
                    />
                    {errors.promoCodeDescription && <small className="text-danger">{errors.promoCodeDescription}</small>}
                  </div>
                  <div className="col-md-4">
                    <label>Promo Code Status</label>
                    <span style={{ color: 'red' }}>*</span>
                    <div className="form-check form-switch" style={{ marginLeft: '25px' }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="promoCodeToggle"
                        checked={isActive}
                        onChange={handleToggle}
                        style={{
                          backgroundColor: isActive ? '#01B074' : '',
                          fontSize: '25px',
                          border: isActive ? 'none' : '',
                          outline: isActive ? 'none' : '',
                        }}
                      />
                      <label className="form-check-label" htmlFor="promoCodeToggle">
                        {isActive ? 'Active' : 'Deactivate'}
                      </label>
                    </div>
                    {errors.isActive && <small className="text-danger">{errors.isActive}</small>}
                  </div>
                  <div className="col-md-4">
                    <label>Delivery Charge Waiver</label>
                    <div className="form-check form-switch" style={{ marginLeft: '25px' }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={deliveryChargeWaiver}
                        onChange={() => setDeliveryChargeWaiver(!deliveryChargeWaiver)}
                        style={{
                          backgroundColor: deliveryChargeWaiver ? '#01B074' : '',
                          fontSize: '25px',
                          border: deliveryChargeWaiver ? 'none' : '',
                          outline: deliveryChargeWaiver ? 'none' : '',
                        }}
                      />
                      <label className="form-check-label">
                        {deliveryChargeWaiver ? 'Yes' : 'No'}
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <label>Cashback Offer</label>
                    <div className="form-check form-switch" style={{ marginLeft: '25px' }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={cashbackOffer}
                        onChange={() => setCashbackOffer(!cashbackOffer)}
                        style={{
                          backgroundColor: cashbackOffer ? '#01B074' : '',
                          fontSize: '25px',
                          border: cashbackOffer ? 'none' : '',
                          outline: cashbackOffer ? 'none' : '',
                        }}
                      />
                      <label className="form-check-label">
                        {cashbackOffer ? 'Yes' : 'No'}
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <label>Applied Automatically</label>
                    <div className="form-check form-switch" style={{ marginLeft: '25px' }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={appliedAutomatically}
                        onChange={() => setAppliedAutomatically(!appliedAutomatically)}
                        style={{
                          backgroundColor: appliedAutomatically ? '#01B074' : '',
                          fontSize: '25px',
                          border: appliedAutomatically ? 'none' : '',
                          outline: appliedAutomatically ? 'none' : '',
                        }}
                      />
                      <label className="form-check-label">
                        {appliedAutomatically ? 'Yes' : 'No'}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vendor-form-actions">
            <button type="button" className="vendor-form-cancel" onClick={() => navigate('/view-promocode')}>Cancel</button>
            <button type="button" className="vendor-form-submit" onClick={handleUpdatePromoCode}>Update Promo Code</button>
          </div>
        </div>
        <div className="vendor-form-footer">
          <Footer />
        </div>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={{ zIndex: 9999 }}
        />
      </div>
    </>
  );
};

export default UpdatePromoCode;